


































import tokenProvider from "axios-token-interceptor";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import i18n from "@/Plugin/i18n";
import BaseVue from "@/core/BaseVue";
import LanguageService from "./services/language.service";
import RoleRequest from "./components/roleRequest/roleRequest.vue";

import CountryService from "@/services/country.service";
import myMSALObj from "./config/azure-b2c/settings";
import User from "./models/security/user.model";
import UserBasicInformation from "./models/security/user-basic-information.model";
import UserService from "./services/user.service";
import { AuthResponse } from "msal";

@Component({
  components: { RoleRequest },
})
class App extends Vue {
  $authService: any;
  requestObj = {
    redirectUri: process.env.VUE_APP_BASE_URL,
    scopes: [
       "https://mescytportal.onmicrosoft.com/fondocyt-portal/user_impersonation",
       "https://mescytportal.onmicrosoft.com/fondocyt-portal/openid",
       "https://mescytportal.onmicrosoft.com/fondocyt-portal/offline_access"
      //"https://whitecape.onmicrosoft.com/whitecape/user_impersonation",
      //"https://whitecape.onmicrosoft.com/whitecape/openid",
      //"https://whitecape.onmicrosoft.com/whitecape/offline_access",
    ],
  };
  baseUri = process.env.VUE_APP_BASE_API_URL;
  loading = true;
  cookies: boolean | null =
    localStorage.getItem("cookies") === "true" ? true : null;
  searchingCookies = true;
  cookieLoadingKey = 0;
  cookieCheckTimeout: number | null = null;
  receiveCookieMessage: any = null;
  checkCookiesAgain: any = null;

  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get user() {
    return this.$store.state.user;
  }

  created() {
    this.setup();
    this.registerHttpInterceptor();
    this.alertErrorDisabledUser();
    this.setLanguages();
    //this.getUser(this);
  }
  mounted() {}

  setup() {
    this.$forceUpdate();
    this.$store.commit("set_loading", false);

    this.startCookieSearchTimeout();

    this.receiveCookieMessage = (evt) => {
      const allowedOrigin = new URL(this.baseUri).origin;

      if (evt.origin !== allowedOrigin) {
        return;
      }

      if (this.cookieCheckTimeout) {
        clearTimeout(this.cookieCheckTimeout);
        this.cookieCheckTimeout = null;
      }

      if (evt.data === "MM:3PCunsupported") {
        this.cookies = navigator.cookieEnabled;
        localStorage.setItem("cookies", String(this.cookies));
        this.finishCookieSearch();
      } else if (evt.data === "MM:3PCsupported") {
        this.cookies = true;
        localStorage.setItem("cookies", "true");
        this.finishCookieSearch();
      }
    };
    window.addEventListener("message", this.receiveCookieMessage, false);

    this.checkCookiesAgain = () => {
      if (this.cookies && !this.searchingCookies) {
        return;
      }
      if (document.visibilityState && document.visibilityState !== "visible") {
        return;
      }

      this.searchingCookies = true;
      this.cookieLoadingKey++;
      this.startCookieSearchTimeout();
      var iframe = this.$refs.iframeCookies as HTMLIFrameElement;
      if (iframe) {
        iframe.src = this.baseUri + "/cookies-2.html?t=" + new Date().getTime();
      }
    };

    window.addEventListener("focus", this.checkCookiesAgain, false);
    document.addEventListener("visibilitychange", this.checkCookiesAgain, false);
  }

  startCookieSearchTimeout() {
    if (this.cookieCheckTimeout) {
      clearTimeout(this.cookieCheckTimeout);
    }
    this.cookieCheckTimeout = window.setTimeout(() => {
      this.cookieCheckTimeout = null;

      // Si el iframe no responde, usamos las cookies del navegador como respaldo.
      if (this.cookies === null) {
        this.cookies = navigator.cookieEnabled;
        localStorage.setItem("cookies", String(this.cookies));
      }

      this.finishCookieSearch();
    }, 5000);
  }

  finishCookieSearch() {
    this.searchingCookies = false;
    this.cookieLoadingKey++;
    var loadingDiv = document.getElementById("loadingDiv");
    if (loadingDiv) {
      loadingDiv.remove();
    }
    this.$nextTick(() => {
      var loadingOverlays = document.querySelectorAll(".cookie-loading-overlay.loading-overlay");
      loadingOverlays.forEach((overlay: any) => {
        if (overlay.parentNode && !this.searchingCookies) {
          overlay.parentNode.removeChild(overlay);
        }
      });
      this.$forceUpdate();
    });
  }

  beforeDestroy() {
    if (this.cookieCheckTimeout) {
      clearTimeout(this.cookieCheckTimeout);
      this.cookieCheckTimeout = null;
    }
    if (this.receiveCookieMessage) {
      window.removeEventListener("message", this.receiveCookieMessage, false);
    }
    if (this.checkCookiesAgain) {
      window.removeEventListener("focus", this.checkCookiesAgain, false);
      document.removeEventListener("visibilitychange", this.checkCookiesAgain, false);
    }
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal) {
    // this.getUser(this);
  }

  setLanguages() {
    var locale = "do";
    var currentLocale = localStorage.getItem("currentLocale");
    if (currentLocale) {
      locale = currentLocale;
    }
    var languageService = new LanguageService();

    languageService.getJSON().then((msg) => {
      localStorage.setItem("locales", JSON.stringify(msg));
      i18n.setLocaleMessage(locale, msg[locale]);
    });
  }
  registerHttpInterceptor() {
    var self = this as any;

    self.$http.interceptors.request.use(
      async (request: any) => {
        var token = localStorage.getItem("token");
        if (token) {
          request.headers.common["Authorization"] = `Bearer ${token}`;
        } else {
          await setToken(request);
        }
        return request;
      },
      async (error: any) => {
        return Promise.reject(error);
      }
    );

    self.$http.interceptors.response.use(undefined, async (error) => {
      const originalRequest = error.config;
      if (error.response && error.response.status === 401) {
        if (!originalRequest._retry) {
          originalRequest._retry = true;
          await setToken(self.$http.defaults, originalRequest);
          return self.$http(originalRequest);
        }
      }
      return Promise.reject(error);
    });
    const setToken = async (request: any, originalRequest = null) => {
      const res = (await this.getToken()) as AuthResponse;
      if (res && res.accessToken) {
        request.headers.common["Authorization"] = `Bearer ${res.accessToken}`; // This fails if MSAL requested a new token

        if (originalRequest) {
          originalRequest.headers.Authorization =
            request.headers.common["Authorization"];
        }

        localStorage.setItem("token", res.accessToken);
      } else {
        var token = localStorage.getItem("token");
        request.headers.common["Authorization"] = `Bearer ${token}`;
        if (originalRequest) {
          originalRequest.headers.Authorization =
            request.headers.common["Authorization"];
        }
      }
    };
  }

  async getToken(secondChance: boolean = false): Promise<any> {
    var self = this;
    return await new Promise(async (resolve, reject) => {
      if (self.cookies === true) {
        await myMSALObj
          .acquireTokenSilent(self.requestObj)
          .then((loginResponse) => {
            if (!loginResponse.accessToken) {
              loginResponse.accessToken = localStorage.getItem("token");
            } else {
              localStorage.setItem("tokenObj", JSON.stringify(loginResponse));
              localStorage.setItem("token", loginResponse.accessToken);
              self.$store.commit("set_token", loginResponse.accessToken);
            }
            if (
              !self.user.id &&
              !localStorage.getItem("TheUserIsAlreadysended")
            ) {
              var account = myMSALObj.getAccount();
              var user = {} as any;
              user.adid = account.accountIdentifier;
              user.name = account.idToken.given_name;
              user.lastName = account.idToken.family_name;
              user.email =
                account.idToken.emails && account.idToken.emails.length
                  ? account.idToken.emails[0]
                  : account.userName || "";
              self.$store.commit("set_loading", true);

              localStorage.setItem("TheUserIsAlreadysended", "1");

              var userService = new UserService();
              userService
                .createIfNoExist(user)
                .then((x) => {
                  localStorage.setItem("user", JSON.stringify(x));
                  self.$store.commit("set_user", x);
                  self.$store.commit("set_loading", false);
                })
                .finally(() => {
                  self.$store.commit("set_loading", false);
                  localStorage.removeItem("TheUserIsAlreadysended");
                });
            }

            return resolve(loginResponse);
          })
          .catch(async (error) => {
            console.log("TOKEN ERROR", error);

            if (self.cookies === true) {
              if (!secondChance) {
                await myMSALObj.acquireTokenRedirect(self.requestObj);
                return;
              } else {
                localStorage.clear();
                let newError = new Error(error);
                console.log(error);
                myMSALObj.logout();
                return reject(newError);
              }
            }

            return reject(error);
          });
      } else {
        return reject(new Error("Las cookies de terceros no están disponibles."));
      }
    });
  }

  doLogOut() {
    localStorage.removeItem("id_token_obj");
    localStorage.removeItem("user");
    localStorage.removeItem("cookies");
    this.$authService.logout();
  }

  alertErrorDisabledUser() {
    if (this.user.disabled) {
      this.$buefy.dialog.alert({
        title: "Error",
        message: "message.thisUserIsDisabled",
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: () => this.doLogOut(),
      });
    }
  }
}

export default App;
